/* eslint-disable react-hooks/exhaustive-deps */
import * as yup from "yup";

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Typography } from "@mui/material";
import { useEffect, useState } from "react";

import AutoComplete from "@/components/hookForms/autoComplete";
import { Close } from "@mui/icons-material";
import InputNumber from "@/components/hookForms/inputNumber";
import TextField from "../../../../components/hookForms/textField";
import messages from "@/utils/messages";
import serviceParametrizacao from "@/services/serviceParametrizacao";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { LoadingButton } from "@mui/lab";

interface IProps {
    props: {
        open: boolean;
        campoAberto: string;
        contexto: string;
        descricao: string;
        nomeParametro: string;
        nomeConcessionaria: string;
        concessionariaID: number;
        parametrizacaoID: number;
        tipo: string;
        valor: string;
        valoresPossiveis: string;
        concessionariaDataOptions: any;
    };
    onSuccess: () => void;
    onClose: () => void;
}

function Edit({ props, onSuccess, onClose }: IProps) {
    const [listValues, setListValues] = useState<any[]>([]);
    const [isDisable, setDisable] = useState(false);

    const schema = yup.object().shape({
        valor:
            props.campoAberto === "S" && props.tipo === "Texto"
                ? yup
                      .string()
                      .matches(/^[0-9.,;%-]*$/, "Formato Inválido!")
                      .required(messages.requiredField)
                : yup.string().required(messages.requiredField),
    });

    const {
        handleSubmit,
        control,
        reset,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            valor: "",
        },
    });

    useEffect(() => {
        if (props.open && props.campoAberto === "N") {
            if (props.tipo !== "SimNao") {
                const elems = props.valoresPossiveis.split(";");

                let b: any[] = [];
                b = elems.reduce((newArray, currentValue) => {
                    newArray.push({ value: currentValue, label: currentValue });
                    return newArray;
                }, b);
                setListValues(b);
            } else {
                setListValues([
                    { label: "Sim", value: "Sim" },
                    { label: "Não", value: "Não" },
                ]);
            }
            reset(props);
        }
    }, [props]);

    useEffect(() => {
        if (props) {
            reset(props);
        }
    }, [props]);

    const onSubmit = (values: any) => {
        setDisable(true);

        delete values.errors;

        const updatedValues = {
            ...values,
        };

        serviceParametrizacao
            .update(updatedValues)
            .then((result) => {
                if (result) {
                    toast.success(messages.updateSucess);
                    onClose();
                }
            })
            .catch((err) => {
                toast.error(messages.updateError, err);
            })
            .finally(() => {
                setDisable(false);
                onSuccess();
            });
    };

    return (
        <Dialog
            maxWidth="md"
            fullWidth
            onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    onClose();
                }
            }}
            open={props?.open}
        >
            <DialogTitle>
                Editar parâmetro
                <IconButton
                    aria-label="close"
                    onClick={() => {
                        reset();
                        onClose();
                    }}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <Close />
                </IconButton>
            </DialogTitle>
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogContent dividers>
                    <Grid container sx={{ mb: 1 }}>
                        <Grid item xs={12} md={3}>
                            <Typography variant="subtitle1">Nome:</Typography>
                        </Grid>
                        <Grid item xs={12} md={9}>
                            <Typography>{props.nomeParametro}</Typography>
                        </Grid>
                    </Grid>
                    <Grid container sx={{ mb: 1 }}>
                        <Grid item xs={12} md={3}>
                            <Typography variant="subtitle1">Contexto:</Typography>
                        </Grid>
                        <Grid item xs={12} md={9}>
                            <Typography>{props.contexto}</Typography>
                        </Grid>
                    </Grid>
                    <Grid container sx={{ mb: 1 }}>
                        <Grid item xs={12} md={3}>
                            <Typography variant="subtitle1">Descrição:</Typography>
                        </Grid>
                        <Grid item xs={12} md={9}>
                            <Typography>{props.descricao}</Typography>
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={12} md={3}>
                            <Typography variant="subtitle1">Valor Atual:</Typography>
                        </Grid>
                        <Grid item xs={12} md={9}>
                            <Typography>{props.valor}</Typography>
                        </Grid>
                    </Grid>
                    <Grid container display="flex" alignItems="center">
                        <Grid item xs={12} md={3}>
                            <Typography variant="subtitle1">Concessionária:</Typography>
                        </Grid>
                        <Grid item xs={12} md={9}>
                            <Typography>{props.nomeConcessionaria}</Typography>
                        </Grid>
                    </Grid>
                    <Grid container sx={{ mb: 1 }} display="flex" alignItems="center">
                        <Grid item xs={12} md={3}>
                            <Typography variant="subtitle1">Novo Valor:</Typography>
                        </Grid>
                        <Grid item xs={12} md={9}>
                            {props.open && props.campoAberto === "S" ? (
                                props.tipo === "Texto" ? (
                                    <TextField
                                        id="formEditValor"
                                        name="valor"
                                        label="Valor"
                                        control={control}
                                        error={errors}
                                        maxLength={30}
                                        disabled={!props.open}
                                    />
                                ) : (
                                    <InputNumber
                                        id="formEditValor"
                                        name="valor"
                                        label="Valor"
                                        control={control}
                                        error={errors}
                                        noThousandSeparator
                                        maxLength={20}
                                        disabled={!props.open}
                                    />
                                )
                            ) : (
                                <AutoComplete
                                    id="formEditValor"
                                    name="valor"
                                    label="Valor"
                                    options={listValues}
                                    control={control}
                                    error={errors}
                                    disabled={!props.open}
                                />
                            )}
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                    <Button
                        id="cancelar"
                        onClick={() => {
                            onClose();
                            reset();
                        }}
                        color="warning"
                        variant="contained"
                        style={{ width: "159px", height: "44px" }}
                    >
                        Cancelar
                    </Button>
                    <LoadingButton
                        id="salvar"
                        type="submit"
                        color="primary"
                        variant="contained"
                        loading={isDisable}
                        disabled={isDisable}
                        style={{ width: "159px", height: "44px" }}
                    >
                        Salvar
                    </LoadingButton>
                </DialogActions>
            </form>
        </Dialog>
    );
}

export default Edit;
